import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/shared/abstracts/base.abstract';
import { ImportTypesEnum } from 'src/shared/enums/import-type.enum';
import { DataImportService } from './../../../services/data-import.service';

@Component({
    selector: 'app-import-contacts',
    templateUrl: './import-contacts.component.html',
    styleUrls: ['./import-contacts.component.scss'],
})
export class ImportContactsComponent extends BaseComponent implements OnInit {
    @Output() public elementSizeModification = new EventEmitter<void>();

    public importForm: FormGroup;
    public errorsUpload: string[];
    public uploaded: boolean;

    public get fileControl(): FormControl {
        return this.importForm.get('file') as FormControl;
    }

    public get schoolIdControl(): FormControl {
        return this.importForm.get('schoolId') as FormControl;
    }

    constructor(private fb: FormBuilder, private route: ActivatedRoute, private importService: DataImportService) {
        super();
    }

    ngOnInit(): void {
        this.createForm();
        this.uns = this.route.queryParams.subscribe((params) => {
            this.initForm(+params.id);
        });
    }

    public submit(): void {
        this.errorsUpload = [];
        if (this.importForm.invalid) {
            return;
        }
        this.importService
            .importData({
                dataType: ImportTypesEnum.USERS,
                schoolId: this.schoolIdControl.value,
                file: this.fileControl.value,
            })
            .subscribe(
                () => {
                    this.uploaded = true;
                    this.errorsUpload = [];
                },
                (error: string[]) => {
                    this.errorsUpload = error;
                }
            );
    }

    public onFileChange(event: any): void {
        this.errorsUpload = [];
        const fileUploaded: any = event.target.files[0];
        if (fileUploaded) {
            const reader: FileReader = new FileReader();
            reader.onload = () => {
                this.importForm.patchValue({
                    file: fileUploaded,
                });
                this.elementSizeModification.emit();
            };
            reader.readAsDataURL(fileUploaded);
        }
    }

    private createForm(): void {
        this.importForm = this.fb.group({
            schoolId: [null, Validators.required],
            file: [null, Validators.required],
        });
    }

    private initForm(id: number): void {
        this.importForm.patchValue({
            schoolId: id,
        });
    }
}
